import clsx from 'clsx';
import { FadeIn } from 'components/common/FadeIn';
import Link from 'next/link';
import styles from './footer.module.css';

const footerLinksColumnOne = [
  {
    title: 'About Us',
    className: 'daymadeTypographyMRegular',
    href: '/about-us',
  },
  {
    title: 'How It Works',
    className: 'daymadeTypographyMRegular',
    href: '/how-it-works',
  },
  {
    title: 'Blog',
    className: 'daymadeTypographyMRegular',
    href: '/blog',
  },
  {
    title: 'FAQ',
    className: 'daymadeTypographyMRegular',
    href: '/faq',
  },
  {
    title: 'Contact Us',
    className: 'daymadeTypographyMRegular',
    href: '/contact-us',
  },
];

const footerLinksColumnTwo = [
  {
    title: 'Responsible Play',
    className: 'daymadeTypographyMRegular',
    href: '/responsible-play',
  },
  {
    title: 'Terms & Conditions',
    className: 'daymadeTypographyMRegular',
    href: '/terms-and-conditions',
  },
  {
    title: 'Privacy Policy',
    className: 'daymadeTypographyMRegular',
    href: '/privacy-policy',
  },
];

const SiteLink = ({
  title,
  className,
  href,
}: {
  title: string;
  className?: string;
  href: string;
}) => {
  const id =
    title === 'FAQ'
      ? 'faqlink'
      : title === 'Contact Us'
        ? 'contactuslink'
        : undefined;

  return (
    <Link id={id} className={className} href={href} title={title}>
      {title}
    </Link>
  );
};

export const FooterHeaderItem = ({
  title,
  className,
}: {
  title: string;
  className?: string;
}) => {
  return (
    <h5
      className={clsx(
        styles.linksHeader,
        'daymadeTypographyTaglineAccent',
        className,
      )}
    >
      {title}
    </h5>
  );
};

const FooterLinkColumn = ({
  title,
  col,
  faqLink,
}: {
  title: string;
  col: number;
  faqLink: string;
}) => {
  const mappingGroup = col === 1 ? footerLinksColumnOne : footerLinksColumnTwo;
  return (
    <div>
      <FadeIn onScroll>
        <FooterHeaderItem title={title} />
      </FadeIn>
      <div className={styles.linksColumn}>
        {mappingGroup.map((item, i) => {
          const href = faqLink && item.href === '/faq' ? faqLink : item.href;

          return (
            <FadeIn key={item.title} onScroll delay={0.05 * (i + 1)}>
              <SiteLink
                title={item.title}
                className={item.className}
                href={href}
              />
            </FadeIn>
          );
        })}
      </div>
    </div>
  );
};

export default FooterLinkColumn;
